module.exports = __webpack_public_path__ + "static/Paulina-Salas-45905fa5a110a30bed113f24e5190318.webp";